import { DrawCustomMode } from "@mapbox/mapbox-gl-draw";
import rbush from "geojson-rbush";
import { delay } from "lodash";

import { DRAWING_CONSTANTS } from "fond/constants";
import { feature as toFeature } from "fond/turf";

import drawPointMode from "../../base/drawPoint";
import { canPlacePoint } from "../../base/helper";

import { isValid, pullInPaths } from "./helper";

/**
 * This is a custom mode for drawing ug points in FOND Planner extended.
 * It extends the draw_point mode and adds validation for ug paths.
 */
const drawPoint: DrawCustomMode = {
  ...drawPointMode,

  onClick: function (this, state, e) {
    if (!canPlacePoint(state, e)) return;

    const newPoint = state.point;

    // We allow the point to be created first, then we refresh all colocated
    // paths valid property.
    delay(() => {
      const tree = rbush();
      tree.load(this._ctx.api.getAll());
      pullInPaths.call(this, toFeature(newPoint)).forEach((f) => {
        if (f.id) this._ctx.api.setFeatureProperty(f.id, DRAWING_CONSTANTS.Valid, isValid(f, tree).toString());
        this.doRender(f.id);
      });
    }, 0);
    drawPointMode.onClick?.call(this, state, e);
  },
};

export default drawPoint;
